<template>
    <div class="feedback padding">
    <h1 class="big">
        {{ $t('feedback.title') }}
    </h1>
    <p>
        {{ $t('feedback.pitch') }}
        
        <br />{{ $t('feedback.pitch2') }}

    </p>
    <hr class="spacer half" />
    <Social />    
    <hr class="spacer half" />
      
    
    <transition name="bounce">
        <div v-if="status == 'sending'" class="sending_feedback">
            <h2>{{ $t('feedback.sending') }}</h2>
            <scale-loader  color="rgb(38, 139, 96)" height="200px" width="200px">heyas</scale-loader>
            <hr class="spacer" />

        </div>
    </transition>

    <transition name="bounce">
        <div v-if="status == 'sent'" class="sending_feedback">
            <h2>{{ $t('feedback.sent') }}</h2>
            <img class="popin" src="icons/ok_100.png" />
            <hr class="spacer" />
        </div>
    </transition>
    
    <div v-if="status == ''">
        <div>
            <p>
            {{ $t('feedback.rating.prompt') }}
            </p>
            
            <star-rating
              :star-size="20" v-model="rating"
              :show-rating="false"
              active-color="rgb(38, 139, 96)"
              border-color="#000"
              :border-width=1
              :rounded-corners="true"
              ></star-rating>
          </div>
          <hr class="spacer half" />
          <div>
          
              <p>
                {{ $t('feedback.message.prompt') }}
                </p>
            <textarea
            id="feedback"
            v-model="feedback_message"
            :placeholder="$t('feedback.message-placeholder')"
            :rows="8"
            :max-rows="9"
            />         
            
        </div>
          <hr class="spacer half" />
        <div>

            <p>
            {{ $t('feedback.email.prompt') }}
            </p>
            <input type="text" id="email" v-model="email" required/>
            <span v-if="email_is_valid">
                <img class="feedback-badge" src="icons/ok_30.png"/> 
            </span>
            <span v-else-if="email_is_valid === false">
                <img class="feedback-badge" src="icons/warning_30.png"/>  {{ $t('feedback.email-not-valid') }} 
            </span>

            <span v-if="email_required & $data._has_clicked_send">
                <img class="feedback-badge" src="icons/warning_30.png"/>  {{ $t('feedback.email-please') }} 
            </span>
                        
            <p>
                <input type="checkbox" v-model="newsletter"  id="newsletter">
                <label for="newsletter">{{ $t('feedback.subscribe.newsletter') }}</label>
            </p>
            <p>
                <input type="checkbox" v-model="promotional" value="bar" id="promotional">
                <label for="promotional">{{ $t('feedback.subscribe.promotional') }}</label>
            </p>
            
        </div>
          <hr class="spacer half" />
        <div>
        <button :class="submit_button_class" v-on:click="submit()" >{{ $t('feedback.submit') }}<img src="icons/continue_right_18_white.png" /></button>
        </div>
        </div>
        <hr class="spacer" />
        </div>
        
        
    </div>    
</template>

<script>

import Social from './Social.vue'
import StarRating from 'vue-star-rating'
import ScaleLoader from 'vue-spinner/src/PulseLoader.vue'
import Persistent from '../mixins/Persistent.js'

export default {
    mixins: [ Persistent ],
    components: {
        Social, StarRating, ScaleLoader
    },
    data: function(){
        return {
            feedback_message: "",
            email: "",
            rating: null,
            newsletter: true,
            promotional: true,
            _has_clicked_send: false
        }
    },
    props: {
        status: {
            type: String,
            default: "unsent" //unsent / sending / sent
        }
    },
    computed: {
        email_is_valid : function(){
            if(this.email == ""){
                return null
            }
            return this.string_is_email(this.email)
        },
        submit_button_class: function(){
            if(this.email_is_valid === true){
                return "big green"
            }
            return "big grey"
        },
        email_required : function(){
            if(this.newsletter || this.promotional){
                if(this.email == "" || !this.email_is_valid){
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        email : function(){
            this.$data._has_clicked_send = false

        }
    },
    methods: {
        string_is_email: function(email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        submit: function(){
            if(this.email_required){
                if( this.email_is_valid === null ){
                    this.$data._has_clicked_send = true
                }
                return false
            } else {
                this.notify_parent()
                this.$emit('submit')
            }
        }
    }   
    
}

</script>

<style >

input#email {
    height: 2.5em;
    width: 250px;
}

img.feedback-badge {
    margin-left: 12px;
    height: 1.5em;
    vertical-align: middle;
}

.bounce-enter-active {
  animation: bounce-in .8s;
}
.bounce-leave-active {
  animation: bounce-in .01s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

textarea#feedback {
    width: 90%;
}

textarea#feedback, input#email {
    background-color: #ccc;
    border: 1px solid #fff;
    border-radius: 10px;
    padding: .5em;
}

div.feedback {
    text-align: left;
}

div.sending_feedback {
    padding: 3em;
    text-align: center;
}
</style>